import {
	DBxEvent
} from "cartovista";
import {show} from "../appTools/Alerts";
import "../../css/ReloadDataTool.css";

var reloadDataToolBtnHtml = '<button type="button" id="ReloadDataTool_btn" class="k-button k-button-icon" title="Actualiser : Actualiser les données de l\'application">' +
                                    '<span  class="cv-icon bi bi-arrow-clockwise"></span>' +
                                '</button>';

export default class ReloadDataTool {
    constructor(loadData) {
        window.cartovista.addOneTimeEventListener("ServerDataInitialized", this._onServerDataInitialized, this);
        this._$reloadDataBtn = $(reloadDataToolBtnHtml);
        this._$reloadDataBtn.click(this._onReloadDataBtnClicked.bind(this, loadData));
        $("#ReloadDataTool").html(this._$reloadDataBtn);
    }

    _onServerDataInitialized(evt) {
        new Promise(function(resolve, reject) {
            if (!window.cartovista.getMap(C.MAP.ID)) {
                window.cartovista.addOneTimeEventListener(cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, resolve, this);
            } else {
                resolve();
            }
        }).then(function() {
            this._map = window.cartovista.getMap(C.MAP.ID);
            this._drawingLayer = this._map.getLayer(C.LAYERS.DRAWING_LAYER.LAYER_ID);
        }.bind(this));
    };

    async _onReloadDataBtnClicked(loadData) {
        if (!this._drawingLayer.drawingFeatures.length) {
            window.cartovista.dispatchEvent(new DBxEvent("ReloadDataTool_ReloadStarted"));
            show("ReloadDataTool_ReloadStarted");
            this._$reloadDataBtn.prop("disabled", true).addClass("k-state-disabled");
            this._removeData();
            loadData().then(function() {
                    window.cartovista.dispatchEvent(new DBxEvent("ReloadDataTool_ReloadCompleted"));
                    setTimeout(function() {
                        show("ReloadDataTool_ReloadCompleted");
                    }, 1000);
                    this._$reloadDataBtn.prop("disabled", "").removeClass("k-state-disabled");
                    this._map.activeThemeSet = this._map.getThemeSet(this._activeThemeSetId);
                }.bind(this));
        } else {
            show("ReloadDataTool_ErrorDrawingMode");
        }
    };

    _removeData() {
        this._activeThemeSetId = this._map.activeThemeSet ? this._map.activeThemeSet.id : null;
        this._map.activeThemeSet = null;
        this._removeLayers();
    };

    _removeLayers() {
        _.forEach(C.LAYERS, function(layerConfig) {
            var layer = this._map.getLayer(layerConfig.LAYER_ID);
            if (layer) {
                var datatableId = typeof layerConfig.DATATABLE_ID != "undefined" ? layerConfig.DATATABLE_ID : "AttributesDataTable_" + layerConfig.LAYER_ID;
                var dataTable = layer.getDataTable(datatableId);
                this._removeLayerFeatures(layer);
                this._removeLayerDataRows(dataTable);
            }
        }.bind(this));
    };

    _removeLayerFeatures(layer) {
        layer.getSimpleFeatures(null, function(result) {
            if (result.features.length > 0) {
                layer.removeFeatures(result.features);
            }
        }, this, false);
    };

    _removeLayerDataRows(dataTable) {
        dataTable.removeAllDataRows();
    };

}
